import { API_URL } from './../../../../../actions/utilAction';
import { actionCreator,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    extractDataFromObject,
    jsonApiHeader,
    showSuccessMessage,
    showWarningMessage,
    showErrorMessage,
} from './../../../../../actions/utilAction';

export { jsonApiHeader,
    actionCreator,
    checkHttpStatus,
    createSearchUrl,
    create_post_data,
    showSuccessMessage,
    extractDataFromObject,
    showWarningMessage,
    showErrorMessage,
   API_URL,
};

export const GET_NOTE_TYPES_LIST_API = `${API_URL}/MasterNoteType/GetMasterNoteTypes`;
export const POST_NOTE_TYPE_API = `${API_URL}/MasterNoteType/SaveMasterNoteType`;
export const GET_NOTE_TYPE_DETAILS_API = `${API_URL}/MasterNoteType/GetMasterNoteTypeById`;
export const DELETE_NOTE_TYPE_API = `${API_URL}/MasterNoteType/DeleteMasterNoteType`;
export const NoteActionTypes = {
  get_noteTypesList: createRequestActionTypes('GET_NOTETYPESLIST'),
  post_noteType: createRequestActionTypes('POST_NOTETYPE'),
  get_noteTypeDetails: createRequestActionTypes('GET_NOTETYPEDETAILS'),
  delete_noteType: createRequestActionTypes('DELETE_NOTETYPE'),
};

export const MODULE = 'MASTER_NOTETYPE';


// WEBPACK FOOTER //
// ./src/modules/Masters/components/note-master/constants/ApiConstants.js